<template>
  <BaseGame
    :gameId="7"
    gameName="TheDecoder"
    :assets="Assets"
    :gamePlayCopy="gamePlayCopy"
  />
</template>

<script setup>
import BaseGame from '@/components/GamePlay/Common/BaseGame.vue';
import Assets from './data/assets.ts';
import gamePlayCopy from './data/copy.ts';
</script>

<style lang="scss">
@use '@/css/games/games/the-decoder.scss';
</style>
